import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import EditIcon from "@mui/icons-material/Edit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import StraightIcon from "@mui/icons-material/Straight";
import LinkIcon from "@mui/icons-material/Link";
// import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Avatar,
  Box,
  Button,
  Chip,
  FormHelperText,
  Link,
  MenuItem,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useContext, useRef, useState } from "react";
import { icons } from "../../assets";
import { calculateGpChange, formatWebNumbers } from "../../utils/helper";
import GlobalButton from "../button";
import CustomDropDown from "../select";
import { AppContext } from "../../lib/Context";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { LEAD_STAGE } from "../../lib/Variable";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import CustomCheckbox from "../../components/checkbox";

const tableStyle = {
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: "primary.moonGlow",
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: "secondary.dark",
      fontSize: "0.8rem",
    },

  "& .MuiTableCell-root .MuiTypography-body1 ": {
    fontSize: "0.875rem",
  },
};

const SaleStatus = [
  "Lead",
  "Contract Sent",
  "Sale",
  "Provisioning",
  "Live",
  "Future Live",
  "Delayed Live",
  "Rework",
  "Winback",
  "Cancel Pre-Live - In Contract",
  "Cancel Pre-Live - Better price",
  "Cancel Pre-Live - Change of mind or Not interested",
  "Cancel Pre-Live - No reason disclosed",
  "Cancel Pre Live - Incorrect Product Sold",
  "Cancel Pre-Live - Incompatible product",
  "Delete Lead",
  "Duplicate lead",
  "Test",
];

const SaleStatusForAgent = ["Lead", "Contract Sent", "Sale", "Delete Lead"];

const DOCUSIGN_STATUS = [
  {
    title: "Contract-Completed",
    value: "envelope-completed",
  },
  {
    title: "Contract-Delivered",
    value: "envelope-delivered",
  },
  {
    title: "Contract-Sent",
    value: "envelope-sent",
  },
  {
    title: "Contract-Resend",
    value: "envelope-resend",
  },
  {
    title: "Contract-Not-Sent",
    value: "envelope-not-sent",
  },
];

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(10),
    border: "1px solid #dadde9",
  },
}));

export default function DynamicTable({
  tableWidth,
  minWidth,
  tableHeader,
  tableData,
  displayRows,
  showDelete,
  handleDelete,
  showEdit,
  handleEdit,
  showLogin,
  handleLoginAs,
  showDownloadBtn,
  handleDownloadInvoice,
  handleShowPassword,
  showDetail,
  handleNavigateToDetail,
  showPagination = true,
  handleUpdateSaleStatus,
  handleUpdateLeadStatus,
  handleOpenDialog,
  handleNoteDialogdata,
  handleEditLeadProposal,
  handlChangeBroadbandStatus,
  handleUpdateDocusignStatus,
  handleViewTarrifDescription,
  onNaviagteAgentsCalendarPage,
  showDeleteIcon,
  handleChangeCustomStatus,
  isPaginated,
  onPageChange,
  onRowsPerPageChange,
  paginatedData,
  handleLinkedContract,
  handleChangeCustomExport,
  handleOpenImagesDialog,
  handleAllowToPreview,
  handleUpdateLeadStageStatus,
  handleChangeCpsTerms,
  handleUpgradeContract,
  showUpgradeContract,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(-1);
  const [expandedChartRow, setExpandedChartRow] = useState(null);
  const openDialog = useRef(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const { userData } = useContext(AppContext);

  const isAdmin = userData?.designation === "Admin";

  const renderSaleStatus =
    userData?.designation === "Admin" ? SaleStatus : SaleStatusForAgent;

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const IconButton = ({ children, handleClick }) => {
    return (
      <Box
        width={22}
        height={22}
        sx={{ cursor: "pointer" }}
        onClick={handleClick}
      >
        {children}
      </Box>
    );
  };

  return (
    <TableContainer sx={tableStyle}>
      <Table
        sx={{
          width: tableWidth ? tableWidth : "100%",
          minWidth: minWidth ? minWidth : "900px",
        }}
      >
        <TableHead>
          <TableRow>
            {tableHeader?.map((header) => (
              <TableCell key={header}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
            ? tableData?.slice(
                isPaginated
                  ? paginatedData.page * paginatedData.limit
                  : page * rowsPerPage,
                isPaginated
                  ? paginatedData.page * paginatedData.limit +
                      paginatedData.limit
                  : page * rowsPerPage + rowsPerPage,
              )
            : tableData
          )?.map((row, index) => {
            // const {
            //   address1,
            //   address2,
            //   town,
            //   city,
            //   postCode
            // } = row?.generalInfo || {};

            // const customerAllAddress = [
            //   address1,
            //   address2,
            //   town,
            //   city,
            //   postCode
            // ]
            //   .filter(Boolean) // removes undefined, null, or empty string
            //   .join(", ");

            const customerAddress1 = row?.generalInfo?.address1;
            const customerAddress2 = row?.generalInfo?.address2;
            const customerAllAddress = `${customerAddress1}, ${
              row.generalInfo?.town ? `${row.generalInfo?.town},` : ""
            } ${row?.generalInfo?.city} ${row?.generalInfo?.postCode}`;

            const renderCliNumber = (params) => {
              return params?.map((val, index) => {
                const renderValue = val.cliNumber
                  ? val.mobileNo || "__"
                  : "New Connection";
                return (
                  <Typography key={index}>
                    CLI {index + 1} {renderValue}
                  </Typography>
                );
              });
            };

            const profitPercentage = (params) => {
              let x = (params.totalGrossProfit / 27) * 100;
              return x.toFixed(2);
            };
            // const profitPercentage = (params) => {
            //   let x = (params.totalGrossProfit / params.totalRevenue) * 100;
            //   return x.toFixed(2);
            // };

            const isCPS = row?.productType?._id === "68557af86832bb8213147db1";

            const serviceTableData = (params) => {
              return params.map((val) => {
                let packagesName = [];

                if (val.legacyTariff.isSelected) {
                  val.lineValues.map((leg) => {
                    packagesName.push(leg?.legacy?.value || "NA");
                  });
                }

                if (val.digitalTariff.isSelected) {
                  val.lineValues.map((leg) => {
                    packagesName.push(leg?.ngnValue?.value || "NA");
                  });
                }
                return packagesName;
              });
            };

            return (
              <React.Fragment key={index}>
                <TableRow id={`lead-row-${row._id}`}>
                  {displayRows.map((val) => {
                    return (
                      <React.Fragment key={val}>
                        {val === "idAscending" ? (
                          <TableCell>{index + 1}</TableCell>
                        ) : val === "agent_details" ? (
                          <TableCell>
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={1}
                            >
                              <Avatar
                                src={row.image}
                                sx={{ height: 55, width: 55 }}
                              />
                              <Stack>
                                {/* <Typography>ID :{row._id}</Typography> */}
                                <Typography>{row.username}</Typography>
                                <Typography>
                                  Phone Number: {row.contact}
                                </Typography>
                                <Typography>
                                  {`Joining Date: ${moment(
                                    row.createdAt,
                                  ).format("DD.MM.YY [at] HH:mm")}`}
                                </Typography>
                              </Stack>
                            </Stack>
                          </TableCell>
                        ) : val === "agent_email" ? (
                          <TableCell>
                            <Typography>Email : {row.email}</Typography>
                          </TableCell>
                        ) : val === "agent_password" ? (
                          <TableCell>
                            <Stack
                              direction={"row"}
                              spacing={1}
                              alignItems={"center"}
                            >
                              <VisibilityOutlinedIcon
                                onClick={() => handleShowPassword(row, index)}
                                sx={{
                                  color: "text.coolGrey",
                                  cursor: "pointer",
                                }}
                              />
                            </Stack>
                          </TableCell>
                        ) : val === "customer_details" ? (
                          <TableCell>
                            {row.linkedContract &&
                              location.pathname !== "/edit-lead" && (
                                <Chip
                                  onClick={() =>
                                    handleLinkedContract(row, index)
                                  }
                                  sx={{
                                    height: "auto",
                                  }}
                                  icon={<LinkIcon />}
                                  label={"Linked"}
                                />
                              )}
                            <Typography fontWeight={600}>
                              Account No: {row.accountNo}
                            </Typography>

                            <Typography>
                              {row.generalInfo.agent} (Agent)
                            </Typography>
                            <Typography>
                              Customer: {row.generalInfo.name}
                            </Typography>
                            <Typography>
                              {row.generalInfo.businessName}
                            </Typography>
                            {/* <Typography>
                              Contact: {row.generalInfo.mobileNo}
                            </Typography> */}
                            <Typography>{customerAllAddress}</Typography>
                            {/* 
                            {row.generalInfo.businessName && (
                              <>
                                <Typography>
                                  Business Name : {row.generalInfo.businessName}
                                </Typography>
                                <Typography>
                                  Business Type : {row.generalInfo.businessType}
                                </Typography>
                              </>
                            )} */}
                          </TableCell>
                        ) : val === "connectDetails" ? (
                          <TableCell style={{ width: 200 }}>
                            {row.contractSignedAt !== null && (
                              <Typography mb={0.6}>
                                Signed on{" "}
                                {moment(row.contractSignedAt).format(
                                  "DD.MM.YY",
                                )}
                              </Typography>
                            )}
                            {/* <Stack>{renderCliNumber(row.cliData)}</Stack> */}
                            <Stack mb={0.6}>
                              {serviceTableData(row?.cliData)?.length > 0
                                ? serviceTableData(row?.cliData)[0]
                                : "__"}
                            </Stack>
                            {/* <Stack
                              direction={"row"}
                              alignItems={"center"}
                              spacing={1.5}
                            >
                              {[1, 2, 3, 4, 5]?.map((cliValll, indddd) => (
                                <Typography
                                  key={indddd}
                                  variant="body2"
                                  fontWeight={600}
                                >
                                  CLI {indddd + 1}:
                                  <span style={{ fontWeight: 400 }}>
                                    {` ${cliValll}`}
                                  </span>
                                </Typography>
                              ))}
                            </Stack> */}

                            <Typography mb={0.6}>
                              {row?.contractLength?.title || "__"}
                            </Typography>
                            {/* <Typography>
                              Created on{" "}
                              {moment(row.createdAt).format(
                                "DD.MM.YY [at] HH:mm"
                              )}
                            </Typography> */}
                            {row.generalInfo?.liveDate && (
                              <Typography>
                                Live Date{" "}
                                {moment(row.generalInfo?.liveDate).format(
                                  "DD.MM.YY",
                                )}
                              </Typography>
                            )}
                          </TableCell>
                        ) : val === "paymentDetails" ? (
                          <TableCell>
                            <Stack direction="column" spacing={0.7}>
                              <Stack direction="row" alignItems="center">
                                <Box width="120px">
                                  <Typography>Revenue</Typography>
                                </Box>
                                <Typography>
                                  {`£${formatWebNumbers(row.totalRevenue)}`}
                                </Typography>
                              </Stack>
                              <Stack direction="row" alignItems="center">
                                <Box width="120px">
                                  <Typography>Gross Profit</Typography>
                                </Box>
                                <Typography>
                                  {`£${formatWebNumbers(row.totalGrossProfit)}`}
                                </Typography>
                              </Stack>
                              <Stack direction="row" alignItems="center">
                                <Box width="120px">
                                  <Typography>Profit Percentage</Typography>
                                </Box>
                                <Typography>
                                  {`${profitPercentage(row)}%`}
                                </Typography>
                              </Stack>
                              {row?.upgradeContract && (
                                <Stack direction="row" alignItems="center">
                                  <Box width="120px">
                                    <Typography>GP Change</Typography>
                                  </Box>
                                  <Typography>
                                    {`£${formatWebNumbers(calculateGpChange(row))}`}
                                  </Typography>
                                </Stack>
                              )}
                            </Stack>
                          </TableCell>
                        ) : val === "contract_status" ? (
                          <TableCell style={{ textTransform: "capitalize" }}>
                            {row.status.replace("envelope", "contract")}
                          </TableCell>
                        ) : val === "sale_status" ? (
                          <TableCell
                            style={{
                              textTransform: "capitalize",
                              width: "170px",
                            }}
                          >
                            <CustomDropDown
                              value={row.saleStatus}
                              disabled={
                                userData?.designation !== "Admin" &&
                                row.saleStatus === "Sale"
                              }
                              onChange={(e) =>
                                handleUpdateSaleStatus(e.target.value, row)
                              }
                              size={"small"}
                              stylePropos={{
                                width: "200px",
                              }}
                            >
                              {SaleStatus.map((val) => {
                                return (
                                  <MenuItem
                                    value={val}
                                    disabled={!renderSaleStatus.includes(val)}
                                  >
                                    {val}
                                  </MenuItem>
                                );
                              })}
                            </CustomDropDown>
                          </TableCell>
                        ) : val === "agent_email" ? (
                          <TableCell>
                            <Typography>Email : {row.email}</Typography>
                          </TableCell>
                        ) : val === "lead_created_date" ? (
                          <TableCell>
                            <Typography>
                              {moment(row.createdAt).format(
                                "DD.MM.YY [at] HH:mm",
                              )}
                            </Typography>
                          </TableCell>
                        ) : val === "lead_detail" ? (
                          <TableCell>
                            {/* Main Info */}

                            <Typography
                              fontWeight={600}
                              textTransform="capitalize"
                            >
                              {row.username}
                            </Typography>

                            {isAdmin && (
                              <Typography textTransform="capitalize">
                                Agent: {row.agentId?.username}
                              </Typography>
                            )}

                            {row?.productType && (
                              <Typography textTransform="capitalize">
                                Product Type: {row.productType?.name}
                              </Typography>
                            )}

                            {/* {row.businessName && (
                              <Typography textTransform="capitalize">
                                Business Name: {row.businessName}
                              </Typography>
                            )} */}

                            {/* Extra Info in Tooltip */}
                            <HtmlTooltip
                              arrow
                              placement="bottom"
                              title={
                                <Box>
                                  <Typography
                                    fontWeight={600}
                                    textTransform="capitalize"
                                  >
                                    {row.username}
                                  </Typography>
                                  {isAdmin && (
                                    <Typography textTransform="capitalize">
                                      Agent: {row.agentId?.username}
                                    </Typography>
                                  )}
                                  {row?.productType && (
                                    <Typography textTransform="capitalize">
                                      Product Type: {row.productType?.name}
                                    </Typography>
                                  )}
                                  {row.businessName && (
                                    <Typography textTransform="capitalize">
                                      Business Name: {row.businessName}
                                    </Typography>
                                  )}
                                  {row.email && (
                                    <Typography>Email: {row.email}</Typography>
                                  )}
                                  {row.receiverEmail && (
                                    <Typography>
                                      Receiver Email: {row.receiverEmail}
                                    </Typography>
                                  )}
                                  {row.contact && (
                                    <Typography>
                                      Contact: {row.contact}
                                    </Typography>
                                  )}
                                  {row.address && (
                                    <Typography>
                                      Address: {row.address}
                                    </Typography>
                                  )}
                                </Box>
                              }
                            >
                              <Typography
                                variant="body2"
                                color="primary.main"
                                sx={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                View All Details
                              </Typography>
                            </HtmlTooltip>
                          </TableCell>
                        ) : val === "lead_dates" ? (
                          <TableCell>
                            <Stack direction="column" spacing={0.7}>
                              {!isCPS && (
                                <>
                                  <Typography>
                                    Contract End Date:{" "}
                                    {row.contractEndDate
                                      ? moment(row.contractEndDate).format(
                                          "DD.MM.YY",
                                        )
                                      : "__"}
                                  </Typography>
                                  <Typography>
                                    Follow Up Date:{" "}
                                    {row.followUpDate
                                      ? moment(row.followUpDate).format(
                                          "DD.MM.YY",
                                        )
                                      : "__"}
                                  </Typography>
                                </>
                              )}
                              {isCPS && (
                                <Typography>
                                  Meeting Date:{" "}
                                  {row.setMeeting
                                    ? moment(row.setMeeting).format("DD.MM.YY")
                                    : "__"}
                                </Typography>
                              )}
                            </Stack>
                          </TableCell>
                        ) : val === "contract_endDate" ? (
                          <TableCell>
                            <Typography>
                              {row.contractEndDate
                                ? moment(row.contractEndDate).format("DD.MM.YY")
                                : "__"}
                            </Typography>
                          </TableCell>
                        ) : val === "follow_up_date" ? (
                          <TableCell>
                            {row.followUpDate
                              ? moment(row.followUpDate).format("DD.MM.YY")
                              : "__"}
                          </TableCell>
                        ) : val === "current_provider" ? (
                          <TableCell>
                            <Typography>
                              {row.currentProvider || "__"}
                            </Typography>
                          </TableCell>
                        ) : val === "mark_asread" ? (
                          <TableCell>
                            <Stack direction={{ xs: "column" }} spacing={1}>
                              <Button
                                variant="contained"
                                style={{
                                  border: "none",
                                  backgroundColor: "#000000",
                                  fontSize: "13px",
                                  padding: "3px",
                                  paddingX: "4px",
                                  borderRadius: "6px",
                                  gap: "4px",
                                }}
                                onClick={() =>
                                  handleEditLeadProposal(row, index)
                                }
                              >
                                <EditIcon fontSize="small" /> Edit
                              </Button>
                              <Button
                                variant="contained"
                                style={{
                                  border: "none",
                                  backgroundColor: "#FF0000",
                                  fontSize: "13px",
                                  padding: "3px",
                                  paddingX: "4px",
                                  borderRadius: "6px",
                                }}
                                onClick={() =>
                                  handleUpdateLeadStatus(
                                    row,
                                    index,
                                    "Not Converted",
                                  )
                                }
                              >
                                Not Convert lead
                              </Button>
                              <Button
                                variant="contained"
                                style={{
                                  border: "none",
                                  backgroundColor: "#008000",
                                  fontSize: "13px",
                                  padding: "3px",
                                  paddingX: "4px",
                                  borderRadius: "6px",
                                }}
                                onClick={() =>
                                  handleUpdateLeadStatus(
                                    row,
                                    index,
                                    "Converted",
                                  )
                                }
                              >
                                Convert lead
                              </Button>
                            </Stack>
                          </TableCell>
                        ) : val === "note" ? (
                          <TableCell>
                            <Stack direction={"column"} gap={1}>
                              {row?.note && (
                                <GlobalButton
                                  variant="custom_gradient"
                                  title="View note"
                                  startIcon={
                                    <VisibilityOutlinedIcon
                                      sx={{
                                        color: "#FFFFFF",
                                        cursor: "pointer",
                                      }}
                                    />
                                  }
                                  style={{
                                    width: { xs: "100%", sm: 120 },
                                    padding: "5px",
                                    borderRadius: "100px",
                                  }}
                                  handleClickBtn={() =>
                                    handleNoteDialogdata(row)
                                  }
                                />
                              )}
                              {row?.images?.length > 0 && (
                                <GlobalButton
                                  variant="custom_gradient"
                                  title="View Images"
                                  startIcon={
                                    <VisibilityOutlinedIcon
                                      sx={{
                                        color: "#FFFFFF",
                                        cursor: "pointer",
                                      }}
                                    />
                                  }
                                  style={{
                                    width: { xs: "100%", sm: 120 },
                                    padding: "5px",
                                    borderRadius: "100px",
                                  }}
                                  handleClickBtn={() =>
                                    handleOpenImagesDialog(row)
                                  }
                                />
                              )}
                              {row?.attachment && (
                                <Link href={row.attachment} target="_blank">
                                  <GlobalButton
                                    variant="custom_gradient"
                                    title="View Pdf"
                                    startIcon={
                                      <VisibilityOutlinedIcon
                                        sx={{
                                          color: "#FFFFFF",
                                          cursor: "pointer",
                                        }}
                                      />
                                    }
                                    style={{
                                      width: { xs: "100%", sm: 120 },
                                      padding: "5px",
                                      borderRadius: "100px",
                                    }}
                                  />
                                </Link>
                              )}
                              {!row?.attachment &&
                                !row?.note &&
                                row?.attachment && <Typography>__</Typography>}
                            </Stack>
                          </TableCell>
                        ) : val === "note_created_date" ? (
                          <TableCell>
                            {moment(row.createdAt).format(
                              "DD.MM.YY [at] HH:mm",
                            )}
                          </TableCell>
                        ) : val === "note_createdBy" ? (
                          <TableCell>{row.createdBy || "_"}</TableCell>
                        ) : val === "broadband_status" ? (
                          <TableCell>
                            <Switch
                              size="small"
                              checked={row?.status}
                              onChange={(e) =>
                                handlChangeBroadbandStatus(
                                  row,
                                  e.target.checked,
                                )
                              }
                            />
                          </TableCell>
                        ) : val === "custom_status" ? (
                          <TableCell>
                            <Switch
                              size="small"
                              checked={row?.status}
                              onChange={(e) =>
                                handleChangeCustomStatus(row, e.target.checked)
                              }
                            />
                          </TableCell>
                        ) : val === "can_preview" ? (
                          <TableCell>
                            <Switch
                              size="small"
                              checked={row?.canPreview}
                              onChange={(e) =>
                                handleAllowToPreview(row, e.target.checked)
                              }
                            />
                          </TableCell>
                        ) : val === "custom_export" ? (
                          <TableCell>
                            <Switch
                              size="small"
                              checked={row?.canExport}
                              onChange={(e) =>
                                handleChangeCustomExport(row, e.target.checked)
                              }
                            />
                          </TableCell>
                        ) : val === "docusign_status" ? (
                          <TableCell
                            style={{
                              textTransform: "capitalize",
                            }}
                          >
                            <CustomDropDown
                              value={row.status}
                              onChange={(e) =>
                                handleUpdateDocusignStatus(e.target.value, row)
                              }
                              size={"small"}
                              stylePropos={{
                                width: "190px",
                              }}
                            >
                              {DOCUSIGN_STATUS.map((val) => {
                                return (
                                  <MenuItem value={val.value}>
                                    {val.title}
                                  </MenuItem>
                                );
                              })}
                            </CustomDropDown>
                          </TableCell>
                        ) : val === "tariff_description" ? (
                          <TableCell>
                            <GlobalButton
                              variant="custom_gradient"
                              title="See More"
                              startIcon={
                                <VisibilityOutlinedIcon
                                  sx={{
                                    color: "#FFFFFF",
                                    cursor: "pointer",
                                  }}
                                />
                              }
                              style={{
                                width: { xs: "100%", sm: 120 },
                                padding: "5px",
                                borderRadius: "100px",
                              }}
                              handleClickBtn={() =>
                                handleViewTarrifDescription(row)
                              }
                            />
                          </TableCell>
                        ) : val === "logs_changed_date" ? (
                          <TableCell>
                            {moment(row.timestamp).format(
                              "DD.MM.YY [at] HH:mm",
                            )}
                          </TableCell>
                        ) : val === "agent_calendar" ? (
                          <TableCell>
                            <GlobalButton
                              variant={"custom_gradient"}
                              title={"Calendar"}
                              startIcon={<VisibilityOutlinedIcon />}
                              handleClickBtn={() =>
                                onNaviagteAgentsCalendarPage(row, index)
                              }
                            />
                          </TableCell>
                        ) : val === "agent_off_date" ? (
                          <TableCell>
                            {moment(row.date).format("DD.MM.YY")}
                          </TableCell>
                        ) : val === "off_day" ? (
                          <TableCell>
                            {moment(row.date).format("dddd")}
                          </TableCell>
                        ) : val === "report_gpSold" ? (
                          <TableCell>{`£${row?.totalProfit}`}</TableCell>
                        ) : val === "report_gpInProvisioning" ? (
                          <TableCell>{`£${row?.gpInProvisioning}`}</TableCell>
                        ) : val === "report_gpInProvisioning" ? (
                          <TableCell>{`£${row?.gpInProvisioning}`}</TableCell>
                        ) : val === "report_gpLoss" ? (
                          <TableCell>{`£${row?.gpLoss}`}</TableCell>
                        ) : val === "report_totalNetProfit" ? (
                          <TableCell>{`£${row?.totalNetProfit}`}</TableCell>
                        ) : val === "report_mtd" ? (
                          <TableCell>
                            {Number(row?.mtdSold)?.toFixed(1)}
                          </TableCell>
                        ) : val === "report_mtdLive" ? (
                          <TableCell>
                            {Number(row?.mtdLive)?.toFixed(1)}
                          </TableCell>
                        ) : val === "agent_name" ? (
                          <TableCell>{row?.agentId?.username}</TableCell>
                        ) : val === "contract_lengths" ? (
                          <TableCell>
                            {row.contractLengths.join(" , ")}
                          </TableCell>
                        ) : val === "minimum_discount_price" ? (
                          <TableCell>{row.minimumPrice}+</TableCell>
                        ) : val === "agrement_created_by" ? (
                          <TableCell>{row?.createdBy?.username}</TableCell>
                        ) : val === "agrement_status" ? (
                          <TableCell style={{ textTransform: "capitalize" }}>
                            {row?.status.replace("envelope-", "agreement ")}
                          </TableCell>
                        ) : val === "agrement_signed_on" ? (
                          <TableCell>
                            {row.signedAt
                              ? moment(row.signedAt).format("DD.MM.YY")
                              : "__"}
                          </TableCell>
                        ) : val === "lead_stage_status" ? (
                          <TableCell
                            style={{
                              textTransform: "capitalize",
                              width: "170px",
                            }}
                          >
                            {isCPS ? (
                              <CustomDropDown
                                value={row.leadStage}
                                onChange={(e) =>
                                  handleUpdateLeadStageStatus(
                                    e.target.value,
                                    row,
                                  )
                                }
                                size={"small"}
                                stylePropos={{
                                  width: "200px",
                                }}
                              >
                                {LEAD_STAGE.map((val) => {
                                  return (
                                    <MenuItem value={val.value}>
                                      {val.title}
                                    </MenuItem>
                                  );
                                })}
                              </CustomDropDown>
                            ) : (
                              "__"
                            )}
                          </TableCell>
                        ) : val === "cps_terms" ? (
                          <TableCell>
                            <Switch
                              size="small"
                              checked={row?.cpsTerms}
                              onChange={(e) =>
                                handleChangeCpsTerms(row, e.target.checked)
                              }
                            />
                          </TableCell>
                        ) : val === "discount_valid_months" ? (
                          <TableCell>
                            {row?.validMonths === 0 ? "Free" : row?.validMonths}
                          </TableCell>
                        ) : val === "agreemnts_logs_changed_date" ? (
                          <TableCell>
                            {moment(row.changedAt).format(
                              "DD.MM.YY [at] HH:mm",
                            )}
                          </TableCell>
                        ) : val === "agrement_changedBy" ? (
                          <TableCell>{row.changedBy?.username}</TableCell>
                        ) : val === "message" ? (
                          <TableCell>{row.message}</TableCell>
                        ) : val === "actions" ? (
                          <TableCell>
                            <Stack
                              gap={1}
                              direction={"row"}
                              alignItems={"center"}
                            >
                              {showDownloadBtn && (
                                <Tooltip title={`Download Summary`}>
                                  <Stack
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                    onClick={() => {
                                      handleDownloadInvoice(row, index);
                                    }}
                                    sx={{ cursor: "pointer" }}
                                  >
                                    <StraightIcon
                                      sx={{
                                        transform: "rotate(180deg)",
                                        color: "primary.main",
                                      }}
                                    />
                                    <Typography
                                      variant="body2"
                                      fontSize={"0.75rem"}
                                      color={"#343A40"}
                                    >
                                      Download
                                    </Typography>
                                  </Stack>
                                </Tooltip>
                              )}
                              {showDetail && (
                                <IconButton
                                  handleClick={() =>
                                    handleNavigateToDetail(row, index)
                                  }
                                >
                                  <RemoveRedEyeIcon
                                    sx={{ color: "primary.main" }}
                                  />
                                </IconButton>
                              )}
                              {showUpgradeContract && (
                                <Stack mr={0.6}>
                                  <CustomCheckbox
                                    isChecked={row.upgradeContract}
                                    handleChecked={() =>
                                      handleUpgradeContract(row)
                                    }
                                  />
                                </Stack>
                              )}
                              {showEdit && (
                                <IconButton
                                  handleClick={() => handleEdit(row, index)}
                                >
                                  <img
                                    src={icons.editIcon}
                                    alt="edit-icon"
                                    width={"100%"}
                                    height={"100%"}
                                  />
                                </IconButton>
                              )}
                              {showDelete && row.saleStatus === "Test" && (
                                <IconButton
                                  handleClick={() => handleDelete(row, index)}
                                >
                                  <img
                                    src={icons.deleteIcon}
                                    alt="delete-icon"
                                    width={"100%"}
                                    height={"100%"}
                                  />
                                </IconButton>
                              )}
                              {showDeleteIcon && (
                                <IconButton
                                  handleClick={() => handleDelete(row, index)}
                                >
                                  <img
                                    src={icons.deleteIcon}
                                    alt="delete-icon"
                                    width={"100%"}
                                    height={"100%"}
                                  />
                                </IconButton>
                              )}
                              {showLogin && (
                                <IconButton
                                  handleClick={() => handleLoginAs(row, index)}
                                >
                                  <Tooltip title={`Login as ${row.name} `}>
                                    <ArrowRightAltOutlinedIcon
                                      sx={{ color: "primary.main" }}
                                    />
                                    <FormHelperText
                                      sx={{ mt: "-12px", fontSize: "0.6rem" }}
                                    >
                                      Login
                                    </FormHelperText>
                                  </Tooltip>
                                </IconButton>
                              )}
                            </Stack>
                          </TableCell>
                        ) : (
                          <TableCell>
                            <Typography fontSize={13} lineHeight="normal">
                              {row[val]}
                            </Typography>
                          </TableCell>
                        )}
                      </React.Fragment>
                    );
                  })}
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>

      {/* <TablePagination
        sx={{ display: showPagination ? "block" : "none" }}
        rowsPerPageOptions={[10, 25, 50, 100, { label: "All", value: -1 }]}
        component="div"
        count={tableData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}

      {isPaginated ? (
        <TablePagination
          rowsPerPageOptions={[10, 25, 50, 100]}
          component="div"
          count={paginatedData.total}
          rowsPerPage={paginatedData.limit}
          page={paginatedData.page - 1}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      ) : (
        <TablePagination
          sx={{ display: showPagination ? "block" : "none" }}
          rowsPerPageOptions={[10, 25, 50, 100, { label: "All", value: -1 }]}
          component="div"
          count={tableData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </TableContainer>
  );
}
